import React, { useState } from "react"
import { Link } from "react-router-dom"
import { formatINR } from "../constants"
import DaysOverdueBadge from "./DaysOverdueBadge"
import RemindButton from "./RemindButton"
import DemandLetterButton from "./DemandLetterButton"

export default function DuesTable({ overdue = [], upcoming = [], onRefresh }) {
  const [activeTab, setActiveTab] = useState("overdue")

  const rows = activeTab === "overdue" ? overdue : upcoming

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      {/* Tabs */}
      <div className="flex items-center gap-1 border-b border-slate-200 px-4">
        <TabButton
          active={activeTab === "overdue"}
          onClick={() => setActiveTab("overdue")}
          count={overdue.length}
        >
          Overdue
        </TabButton>
        <TabButton
          active={activeTab === "upcoming"}
          onClick={() => setActiveTab("upcoming")}
          count={upcoming.length}
        >
          Upcoming
        </TabButton>
      </div>

      {rows.length === 0 ? (
        <div className="px-6 py-10 text-center text-[13px] text-slate-400">
          {activeTab === "overdue"
            ? "No overdue installments. Great job!"
            : "No upcoming installments in the next 30 days."}
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[13px]">
            <thead className="bg-slate-50 text-left text-slate-500">
              <tr>
                <th className="px-4 py-2.5 font-medium">Customer</th>
                <th className="px-4 py-2.5 font-medium">Project / Unit</th>
                <th className="px-4 py-2.5 font-medium text-right">Amount</th>
                <th className="px-4 py-2.5 font-medium text-right">Balance</th>
                <th className="px-4 py-2.5 font-medium">Due on</th>
                <th className="px-4 py-2.5 font-medium">Status</th>
                <th className="px-4 py-2.5 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.installment_id} className="border-t border-slate-100 hover:bg-slate-50/50">
                  <td className="px-4 py-2.5">
                    <Link
                      to={`/bookings/${row.booking_id}`}
                      className="font-medium text-slate-900 hover:text-blue-600 hover:underline"
                    >
                      {row.customer_name}
                    </Link>
                  </td>
                  <td className="px-4 py-2.5 text-slate-600">
                    {row.project}
                    {row.unit_number && (
                      <span className="ml-1 text-slate-400">/ {row.unit_number}</span>
                    )}
                  </td>
                  <td className="px-4 py-2.5 text-right text-slate-900">{formatINR(row.amount)}</td>
                  <td className="px-4 py-2.5 text-right font-medium text-slate-900">
                    {formatINR(row.balance)}
                  </td>
                  <td className="px-4 py-2.5 text-slate-600">
                    {row.due_on ? new Date(row.due_on).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"}
                  </td>
                  <td className="px-4 py-2.5">
                    <DaysOverdueBadge days={row.days_overdue} />
                  </td>
                  <td className="px-4 py-2.5 text-right">
                    <div className="flex items-center justify-end gap-1">
                      <RemindButton
                        installmentId={row.installment_id}
                        customerName={row.customer_name}
                        onSuccess={onRefresh}
                      />
                      <DemandLetterButton
                        bookingId={row.booking_id}
                        installmentId={row.installment_id}
                        customerName={row.customer_name}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

function TabButton({ active, onClick, count, children }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1.5 px-3 py-3 text-[13px] font-medium border-b-2 transition-colors ${
        active
          ? "border-slate-900 text-slate-900"
          : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
      }`}
    >
      {children}
      {count > 0 && (
        <span
          className={`rounded-full px-1.5 py-0.5 text-[10px] font-medium ${
            active ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-500"
          }`}
        >
          {count}
        </span>
      )}
    </button>
  )
}
